import Marquee from "react-fast-marquee";
import { MarqueColor, MarqueYellow, MarwueeWrapper } from "./Marquee.styled";
import tontake from "../../../assets/img/Tontake_marquee.svg";
import tontake_color from "../../../assets/img/Tontake_marquee_color.svg";
import star_black from "../../../assets/img/star_black.svg";
import star_white from "../../../assets/img/star_white.svg";
import { useSelector } from "react-redux";

export const MarqueeComponent = () => {
  const theme = useSelector((state) => state.app.theme);
  return (
    <MarwueeWrapper>
      <MarqueYellow>
        <Marquee direction='left' gradient={false}>
          {Array.apply(0, Array(20)).map(function () {
            return (
              <>
                &emsp;
                <img src={tontake} />
                &emsp;
                <img src={star_black} />
              </>
            );
          })}
        </Marquee>
      </MarqueYellow>
      <MarqueColor>
        <Marquee direction='right' gradient={false}>
          {Array.apply(0, Array(20)).map(function () {
            return (
              <>
                &emsp;
                <img src={tontake_color} />
                &emsp;
                <img src={theme === "light" ? star_black : star_white} />
              </>
            );
          })}
        </Marquee>
      </MarqueColor>
    </MarwueeWrapper>
  );
};
